
import React from 'react'
import Top from '../components/head'
import Section from '../components/head2'
import Services from '../components/services'
import Slider from '../components/slider'


const Home = () => {
  return (
    <>
        <Top />
        <Section />
        <Services />
        <Slider />
        
    </>
  )
}

export default Home